import {CheckboxTableComponent} from '../../components/layout/checkbox-table/checkbox-table.component';
import {CheckboxAllTableComponent} from '../../components/layout/checkbox-all-table/checkbox-all-table.component';

export class CheckboxTable {
  private checkboxTableComponents: CheckboxTableComponent[] = [];
  private checkboxAllTableComponents: CheckboxAllTableComponent[] = [];
  selectedValues: any[] = [];

  clearCheckboxTable(): void {
    this.selectedValues = [];
    this.checkboxTableComponents = [];
  }

  clearCheckboxAllTable(): void {
    this.checkboxAllTableComponents = [];
  }

  registerCheckboxTableComponents(component: CheckboxTableComponent) {
    if (!this.checkboxTableComponents.includes(component)) {
      this.checkboxTableComponents.push(component);
    }
  }

  registerCheckboxAllTableComponents(component: CheckboxAllTableComponent) {
    if (!this.checkboxAllTableComponents.includes(component)) {
      this.checkboxAllTableComponents.push(component);
    }
  }

  update(): void {
    this.selectedValues = [];
    this.checkboxTableComponents.forEach((componentComponent: CheckboxTableComponent) => {
      if (componentComponent.checked) {
        this.selectedValues.push(componentComponent.value);
      }
    });

    let allChecked = this.isAllChecked();
    this.checkboxAllTableComponents.forEach((componentComponent: CheckboxAllTableComponent) => {
      componentComponent.checked = allChecked;
    });
  }

  isAllChecked(): boolean {
    return this.checkboxTableComponents.every(componentComponent => componentComponent.checked);
  }

  checkAll(): void {
    this.checkboxTableComponents.forEach((componentComponent: CheckboxTableComponent) => {
      componentComponent.checked = true;
    });

    this.update();
  }

  uncheckAll(): void {
    this.checkboxTableComponents.forEach((componentComponent: CheckboxTableComponent) => {
      componentComponent.checked = false;
    });

    this.update();
  }
}
